import { Component, OnInit, ViewChild } from '@angular/core';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';


@Component({
  selector: 'app-holiday-header-system',
  templateUrl: './holiday-header-system.component.html',
  styleUrls: ['./holiday-header-system.component.scss']
})
export class HolidayHeaderSystemComponent implements OnInit {
  button = {}
  customDataSource: any;
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang: any;
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent
  constructor(public gt: genericCustomStoreService,
    public Objects: ObjectsService, public _publicSettingService: publicSettingService, public router: Router,public translate:TranslateService) {
    this._publicSettingService.submit("HolidayHeaderSystem")
    this.customDataSource = _publicSettingService.customDataSource;
    this.button = Objects.button;

    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );

    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
  });
  }
  ngOnInit(): void {
    this._publicSettingService.$Holiday_ReFRESH.subscribe(res => {
      if (res) {
        this._publicSettingService.submit("HolidayHeaderSystem")
        this.customDataSource = this._publicSettingService.customDataSource;
        this.grid.instance.refresh()

      }
    })
  }

  HolidayHeaderWorkSystem(e: any) {
    this.router.navigate(['hr/add-edit-holidaySystem'])
    this._publicSettingService.$Holiday_ID.next(e.key ? e.key : 0)
  }
  addrowfun(name: string) {
    return this.gt.addrow(name)
  }
}
